import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import Toast from "../components/Toast";
import "./EventDetail.css";

export default function EventDetail() {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ show: false, message: "", type: "info" });

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const d = await getDoc(doc(db, "events", id));
        if (d.exists()) setEvent({ id: d.id, ...d.data() });
        else setToast({ show: true, type: "error", message: "Event not found" });
      } catch (err) {
        console.error(err);
        setToast({ show: true, type: "error", message: "Failed to load event" });
      } finally {
        setLoading(false);
        setTimeout(() => setToast({ show: false }), 2500);
      }
    };
    load();
  }, [id]);

  if (loading) return <div className="loading">Loading event...</div>;
  if (!event) return <div className="loading">Event not found.</div>;

  return (
    <div className="event-detail-container">
      <Toast show={toast.show} type={toast.type} message={toast.message} />

      <div className="event-card">
        <div className="event-content">
          {/* Event Image */}
          <div className="event-image">
            {event.image ? (
              <img src={event.image} alt={event.title} />
            ) : (
              <span>No image</span>
            )}
          </div>

          {/* Event Info */}
          <div className="event-info">
            <h2>{event.title}</h2>
            <p className="event-meta">{event.date} • {event.location ?? "Location TBD"}</p>
            <p className="event-description">{event.description}</p>

            {/* Buttons */}
            <div className="event-buttons">
              <Link to={`/register/${event.id}`} className="btn-register">
                Rejister
              </Link>
              <Link to="/events" className="btn-back">
                Back to
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
